<!-- La ficha la escribió un tercero: todo va por interpolación; ligas solo https:// -->
@let f = ficha;
<div class="hom">
  <section class="hom-card hfc" [attr.aria-labelledby]="idTitulo">
    <!-- A la vista siempre: de qué catálogo es, cuándo se verificó y su aviso -->
    <div class="hom-encabezado__fila">
      <div class="hom-encabezado__titulos">
        <p class="hom-kicker">{{ f.catalogo || "Catálogo de Modelos de IA" }}</p>
        <h3 class="hom-h3" [id]="idTitulo">Ficha del catálogo</h3>
      </div>
      <span class="hfc__verificado">Verificada el {{ fechaDmy(f.verificado) }} {{ antiguedad }}</span>
    </div>
    <p class="hom-encabezado__linea">
      {{ f.nombre || "—" }} · {{ f.empresa || "—" }} · <code class="hom-mono">{{ f.modelId || "—" }}</code>
      <!-- La página del modelo en el catálogo: liga solo si es https://; si no, el texto tal cual -->
      @if (esHttps(f.enlace)) {
        · <a class="hfc__liga" [href]="f.enlace" [attr.title]="f.enlace" target="_blank" rel="noopener noreferrer">Ver en el catálogo</a>
      } @else if (f.enlace) {
        · <span class="hfc__crudo">{{ f.enlace }}</span>
      }
    </p>
    <p class="hom-encabezado__linea hom-encabezado__linea--suave">
      Lo que publica el fabricante y opina el catálogo. Informa; no califica: el dictamen sale de lo que midió la homologación.
    </p>
    @if (f.aviso) {
      <p class="hfc__aviso" role="note">{{ f.aviso }}</p>
    }
    @if (vieja) {
      <output class="hom-aviso hfc__anuncio">Ficha verificada hace {{ f.diasVerificada }} días: revisa en el catálogo si hay una más reciente.</output>
    }
    @if (avisoPrecios) {
      <output class="hom-aviso hfc__anuncio">{{ avisoPrecios }}</output>
    }

    <details class="hfc__pliegue">
      <summary>Ver la ficha completa</summary>
      <div class="hfc__cuerpo">
        @if (f.descripcion) {
          <p class="hfc__texto">{{ f.descripcion }}</p>
        }

        <!-- Precios con su moneda, y los datos del modelo -->
        <div class="hfc__dos">
          <div class="hfc__precios">
            @if (precios.length) {
              <div class="hom-tabla-caja">
                <table class="table-page__table hom-interna">
                  <thead>
                    <tr>
                      <th scope="col">Precio por millón de tokens</th>
                      <th scope="col" class="hom-num">{{ f.moneda || "Sin moneda" }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (x of precios; track x.concepto) {
                      <tr>
                        <td>{{ x.concepto }}</td>
                        <td class="hom-num">{{ x.valor | number: "1.2-6" }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <p class="hfc__vacio">La ficha no trae precios.</p>
            }
            @if (f.detallePrecios) {
              <p class="hfc__texto hfc__texto--suave">{{ f.detallePrecios }}</p>
            }
          </div>

          <dl class="hom-procedencia">
            <div><dt>Contexto</dt><dd>@if (num(f.contextoTokens) !== null) { {{ f.contextoTokens | number: "1.0-0" }} tokens } @else { — }</dd></div>
            <div>
              <dt>Salida máxima</dt>
              <dd>
                @if (num(f.salidaMaxTokens) !== null) { {{ f.salidaMaxTokens | number: "1.0-0" }} tokens } @else if (!f.salidaMaxTexto) { — }
                @if (f.salidaMaxTexto) { <span class="table-page__subtext">{{ f.salidaMaxTexto }}</span> }
              </dd>
            </div>
            <div><dt>Lanzamiento</dt><dd>{{ fechaDmy(f.fechaLanzamiento) }}</dd></div>
            <div><dt>Corte de conocimiento</dt><dd>{{ f.corteConocimiento || "—" }}</dd></div>
            <div><dt>Tipo · precio · estado</dt><dd>{{ f.tipo || "—" }} · {{ f.acceso || "—" }} · {{ f.estadoModelo || "—" }}</dd></div>
            <div><dt>Generada por el catálogo</dt><dd>{{ f.generado || "—" }}</dd></div>
          </dl>
        </div>

        <!-- La opinión del catálogo, normal: el índice con su configuración, o dicho que no la indica -->
        <div>
          <h4 class="hfc__sub">Opinión del catálogo</h4>
          <dl class="hom-procedencia">
            <div>
              <dt>Índice de inteligencia</dt>
              <dd>
                @if (num(f.indiceInteligencia) !== null) {
                  <strong>{{ f.indiceInteligencia | number: "1.0-2" }}</strong> · {{ f.indiceConfiguracion || "configuración no indicada" }}
                  @if (esHttps(f.indiceFuenteUrl)) {
                    · <a class="hfc__liga" [href]="f.indiceFuenteUrl" target="_blank" rel="noopener noreferrer">fuente</a>
                  } @else if (f.indiceFuenteUrl) {
                    <span class="table-page__subtext">{{ f.indiceFuenteUrl }}</span>
                  }
                } @else {
                  —
                }
              </dd>
            </div>
            <div><dt>Top del catálogo</dt><dd>@if (num(f.topRank) !== null) { <strong>#{{ f.topRank }}</strong> } @else { — }</dd></div>
            <div><dt>Top de su categoría</dt><dd>@if (num(f.categoryRank) !== null) { <strong>#{{ f.categoryRank }}</strong> } @else { — }</dd></div>
            @if (f.topRankPorQue) {
              <div class="hom-procedencia__ancho"><dt>Por qué ese lugar en el catálogo</dt><dd class="hfc__texto">{{ f.topRankPorQue }}</dd></div>
            }
            @if (f.categoryRankPorQue) {
              <div class="hom-procedencia__ancho"><dt>Por qué ese lugar en su categoría</dt><dd class="hfc__texto">{{ f.categoryRankPorQue }}</dd></div>
            }
          </dl>
        </div>

        @if (listas.length) {
          <div class="hfc__listas">
            @for (l of listas; track l.titulo) {
              <div>
                <h4 class="hfc__sub">{{ l.titulo }}</h4>
                <ul class="hom-razones hfc__lista">
                  @for (x of l.items; track $index) {
                    <li>{{ x }}</li>
                  }
                </ul>
              </div>
            }
          </div>
        }

        @if (benchmarks.length) {
          <div>
            <h4 class="hfc__sub">Benchmarks publicados</h4>
            <div class="hom-tabla-caja">
              <table class="table-page__table hom-interna hfc__tabla">
                <thead>
                  <tr>
                    <th scope="col">Benchmark</th>
                    <th scope="col" class="hom-num">Puntuación</th>
                    <th scope="col">Condición</th>
                    <th scope="col">Fuente</th>
                  </tr>
                </thead>
                <tbody>
                  @for (b of benchmarks; track $index) {
                    <tr>
                      <td>{{ b.nombre || "—" }}</td>
                      <td class="hom-num">@if (num(b.puntuacion) !== null) { {{ b.puntuacion | number: "1.0-4" }} {{ b.unidad || "" }} } @else { — }</td>
                      <td>{{ b.condicion || "—" }}</td>
                      <td>
                        @if (esHttps(b.fuenteUrl)) {
                          <a class="hfc__liga" [href]="b.fuenteUrl" target="_blank" rel="noopener noreferrer">Ver fuente</a>
                        } @else if (b.fuenteUrl) {
                          <span class="table-page__subtext hfc__crudo">{{ b.fuenteUrl }}</span>
                        } @else {
                          —
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        @if (f.notas) {
          <div>
            <h4 class="hfc__sub">Notas</h4>
            <p class="hfc__texto">{{ f.notas }}</p>
          </div>
        }

        <p class="hfc__fuente">
          <span class="hfc__fuente-rotulo">Fuente:</span>
          @if (esHttps(f.fuenteUrl)) {
            <a class="hfc__liga" [href]="f.fuenteUrl" [attr.title]="f.fuenteUrl" target="_blank" rel="noopener noreferrer">{{ f.fuenteEtiqueta || f.fuenteUrl }}</a>
          } @else {
            {{ f.fuenteEtiqueta || "—" }}
            @if (f.fuenteUrl) {
              <span class="table-page__subtext hfc__crudo">{{ f.fuenteUrl }}</span>
            }
          }
        </p>
      </div>
    </details>
  </section>
</div>
